import './WeatherTable.scss';
import { formatDirectionToCompassPoint } from 'app/agriculture/components/StatWithDirection/formatDirectionToCompassPoint';
import { DynamicDirectionIcon } from 'app/agriculture/components/StatWithDirection/DynamicDirectionIcon/DynamicDirectionIcon';
import './WindDirection.scss';

interface Props {
    value: number;
}
export function WindDirection({ value }: Props) {
    const label = `${value.toFixed(1)}° ${formatDirectionToCompassPoint(value, {
        includeHalfWinds: true,
    })}`;

    return (
        <div className="WindDirection">
            <DynamicDirectionIcon direction={value} /> {label}
        </div>
    );
}
